import React from 'react'

import FormDrawerWrapper from '../../../../features/components/FormDrawerWrapper'

import { BOOST_ORGANIC_POST } from '../../../../constants/forms'

import useDrawerFormStyles from '../../../../styles/common/drawerForms'

// todo implement form when needed
const BoostOrganicPost = ({ openBtnClassName }) => {
  const drawerFormClasses = useDrawerFormStyles()

  return (
    <FormDrawerWrapper
      formName={BOOST_ORGANIC_POST}
      title="Boost an organic post"
      openButtonText="Boost an organic post"
      openBtnClassName={openBtnClassName}
    >
      <section className={drawerFormClasses.section}>
        <p style={{ marginTop: 4 }}>Coming soon...</p>
      </section>
    </FormDrawerWrapper>
  )
}

export default BoostOrganicPost
